<template>
  <div id="app" class="w-full min-h-screen overflow-hidden bg-gray-50">
    <div class="w-full min-h-screen flex flex-col items-center justify-center px-4">
      <div class="mb-6">Order Not Found</div>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: 'Order Not Found',
  },
};
</script>
